<template>
  <div class="n-footer">
    <div class="container">
      <!-- logo -->
      <div class="f-logo">
        <!-- <img src="" alt="" /> -->
        <h2>江苏淮田万顷农业科技有限公司</h2>
      </div>

      <p>
        Jiangsu Huaitian Wanqing Agricultural Technology Co., Ltd
      </p>
      <p>电话：18001840286<span style="margin:0 15px;">--</span>邮箱：xuhuanchun@wdwd.com</p>

      <p>公司地址：淮安市淮阴区韩侯北道333号</p>
      <p><a href="https://beian.miit.gov.cn/#/Integrated/index">备案号：苏ICP备2022045533号-1</a></p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.n-footer {
  width: 100%;
  // height: 200px;
  background-color: #2d3237;
  .container {
    height: 100%;
    padding-top: 20px;
    padding-bottom: 10px;
    box-sizing: border-box;
    // logo
    .f-logo {
      width: 300px;
      height: 80px;
      margin: 0 auto;
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
      h2 {
        color: #fff;
        text-align: center;
        line-height: 80px;
      }
    }

    p {
      font-size: 14px;
      color: #888;
      text-align: center;
      margin: 15px 0;
      a {
        color: #888;
      }
    }
  }
}
</style>